import { WhatsappLogo } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const WhatsAppButton = () => {
  return (
    <motion.a
      data-testid="whatsapp-floating-button"
      href="https://wa.me/905302068721?text=Merhaba%2C%20DVT%20Rezidans%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-20 right-4 sm:bottom-6 sm:right-20 z-40 w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-[#25D366]/40 group"
      title="WhatsApp ile iletişime geçin"
    >
      <WhatsappLogo size={32} weight="fill" className="text-white" />
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      {/* Tooltip */}
      <span className="absolute right-full mr-3 whitespace-nowrap bg-[#1A1A1A] text-white text-xs font-['Outfit'] font-medium px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden sm:block">
        WhatsApp ile yazın
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
